import React from 'react';

import EditPanelLabel from '../EditPanelLabel';

import './AnimationTypeSelectorButtons.css';

export const AnimationTypeSelectorButtonGroupText = ({ children }: { children: React.ReactNode }) => (
  <div className="t-utility-label AnimationTypeSelectorButtonGroupText">{children}</div>
);

interface AnimationTypeSelectorButtonGroupProps {
  children: React.ReactNode;
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  label: string;
  id: string;
  size?: 'small' | 'large';
  disabled?: boolean;
}

export const AnimationTypeSelectorButtonGroup: React.FC<AnimationTypeSelectorButtonGroupProps> = ({
  children,
  onClick,
  label,
  id,
  size = 'small',
  disabled = false
}) => {
  return (
    <div>
      <EditPanelLabel htmlFor={id}>{label}:</EditPanelLabel>
      <button
        id={id}
        type="button"
        onClick={onClick}
        className={`AnimationTypeSelectorButtonGroup AnimationTypeSelectorButtonGroup--${size}`}
        disabled={disabled}
      >
        {children}
      </button>
    </div>
  );
};

const AnimationTypeSelectorButtons = ({ children }: { children: React.ReactNode }) => (
  <div className="AnimationTypeSelectorButtons">{children}</div>
);

export default AnimationTypeSelectorButtons;
